export default __webpack_public_path__ + "static/media/port1.784a43c4.jfif";